
import { computed, defineComponent, onMounted, ref, watch } from 'vue'
import { ElIcon, ElRadioGroup, ElRadioButton, ElEmpty, ElPagination } from 'element-plus'
import { ArrowDown, ArrowRight } from '@element-plus/icons-vue'
import MessageManege from '@/pages/MessageCenter/MessageManage.vue'
import api from '@/services'
import vuex from '@/store'
import { SystemMessage } from '@/Tool/LoginSet'
import { $t as lang, formatUrl } from '@/Tool'
export default defineComponent({
  components: {
    MessageManege,
    ElIcon,
    ArrowDown,
    ArrowRight,
    ElRadioGroup,
    ElRadioButton,
    ElEmpty,
    ElPagination,
  },
  setup() {
    const radio = ref('我的消息')
    const messageList = ref([] as any)
    const currentPage = ref(1)
    const total = ref(0)
    const systemMessage = computed(() => vuex.state.systemMessage)
    const checkedMessageId = computed(() => vuex.state.checkedMessageId)
    const checkedBroadcastId = computed(() => vuex.state.checkedBroadcastId)
    const checkedNoticeMessageId = computed(() => vuex.state.checkedNoticeMessageId)
    const userInfo = computed(() => vuex.state.user).value
    const FuncSystemMessage = new SystemMessage({})

    const handleChange = (item: any) => {
      item.active = !item.active
      if (!item.readFlag) {
        item.readFlag = 1
        api.MessageApi.saveMessageRecord({
          data: {
            messageIds: [item.id],
          },
        }).then(() => FuncSystemMessage.getMessageInfo(userInfo.info.userId))
      }
    }

    const getMessageList = (messageId?: number | 'all') => {
      api.MessageApi.queryMessageList({
        data: {
          asc: true,
          keyword: '',
          orderBy: '',
          page: currentPage.value,
          size: 10,
          publishChannel: 1, // 只查小视频消息
        },
      }).then((resp) => {
        const { data } = resp
        let list = data['records'] || []
        if (messageId) {
          if (messageId !== 'all') {
            list = list.map((item: any) => {
              if (item.id === messageId) {
                api.MessageApi.saveMessageRecord({
                  data: {
                    messageIds: [messageId],
                  },
                }).then(() => FuncSystemMessage.getMessageInfo(userInfo.info.userId))
                item.active = true
                item.readFlag = 1
              }
              return item
            })
          }
          vuex.commit('set_data', {
            checkedMessageId: undefined,
          })
        }
        messageList.value = list
        total.value = data['totalRecord'] || 0
      })
    }

    const handleCurrentChange = (val: number) => {
      currentPage.value = val
      getMessageList()
    }

    const handleReadAll = () => {
      if (systemMessage.value.unReadCount === 0) return
      api.MessageApi.modifyAllMessageRead({
        data: {
          // userId: userInfo.info.userId,
        },
      }).then((resp) => {
        if (resp.success) {
          FuncSystemMessage.getMessageInfo(userInfo.info.userId)
          getMessageList()
        }
      })
    }

    const handleTabChange = (val: string) => {
      if (val === '我的消息') {
        currentPage.value = 1
        getMessageList()
      }
    }

    const handleViewDetail = (url: string, type: number | undefined) => {
      if (type == 2) {
        // 合伙人逻辑
        window.open(`${location.origin}/vshow/#/partner?token=${vuex.state.user.token}`)
      } else {
        window.open(formatUrl('cdn', url), '_blank')
      }
    }

    watch(
      () => checkedMessageId.value,
      (id: any) => {
        if (id) {
          if (['ALL_LEVEL'].includes(userInfo.info.dataLevelEnm)) {
            radio.value = '我的消息'
          }
          getMessageList(id)
        }
      },
      {
        immediate: true,
      },
    )

    watch(
      () => checkedBroadcastId.value,
      (id: any) => {
        if (id) {
          if (['ALL_LEVEL'].includes(userInfo.info.dataLevelEnm)) {
            radio.value = '我的消息'
          }
          messageList.value = messageList.value.map((item: any) => {
            if (item.id === checkedBroadcastId.value) item.readFlag = 1
            return item
          })
        }
      },
      {
        immediate: true,
      },
    )

      watch(
          () => checkedNoticeMessageId.value,
          (id: any) => {
              if (id) {
                  if (['ALL_LEVEL'].includes(userInfo.info.dataLevelEnm)) {
                      radio.value = '我的消息'
                  }
                  messageList.value = messageList.value.map((item: any) => {
                      if (item.id === checkedNoticeMessageId.value) item.readFlag = 1
                      return item
                  })
              }
          },
          {
              immediate: true,
          },
      )

    onMounted(() => {
      if (checkedMessageId.value) return
      getMessageList()


      
    })

    function formateDate(time: string) {
      return time?.trim()?.split(' ')[0]
    }

    return {
      radio,
      messageList,
      userInfo,
      currentPage,
      total,
      systemMessage,
      handleChange,
      handleCurrentChange,
      handleReadAll,
      handleTabChange,
      handleViewDetail,
      lang,
      formateDate,
    }
  },
})
